/// <amd-module name="VSSUI/Utilities/DropdownFilter" />
import { IListBoxItem } from "VSSUI/ListBox";
import { arrayEquals } from "VSSUI/Util";
import { IFilter } from "VSSUI/Utilities/Filter";
import { ISelectionRange } from "VSSUI/Utilities/Selection";

export function updateFilterToSelection<T>(values: ISelectionRange[], items: IListBoxItem<T>[], filter: IFilter, filterItemKey: string) {
    const selectedValues: (T | string)[] = [];
    for (let rangeIndex = 0; rangeIndex < values.length; rangeIndex++) {
        for (let i = values[rangeIndex].beginIndex; i <= values[rangeIndex].endIndex; i++) {
            selectedValues.push(items[i].data !== undefined ? items[i].data! : items[i].id);
        }
    }

    const currentState = filter.getFilterItemState(filterItemKey);
    let changesToSet = false;
    if (currentState) {
        changesToSet = !arrayEquals(currentState.value, selectedValues) && (selectedValues.length || currentState.value);
    } else {
        changesToSet = !!selectedValues.length;
    }
    if (changesToSet) {
        if (filterItemKey === "keyword") {
            filter.setFilterItemState(filterItemKey, { value: selectedValues[0] });
        } else {
            filter.setFilterItemState(filterItemKey, { value: selectedValues, operator: currentState?.operator });
        }
    }
}
